import React from "react";
import webui, { BaseComponent } from "@tinqin/tinqin-web-ui";
import Link from "./Link";
import LinksContainer from "./LinksContainer";

const extractComponentProps = webui.getUtils().extractComponentProps;
const closeBurgerAction = {
    actionType: "toggleDisplay",
    target: "un-burger",
    fields: [
        {
            name: "selectBy",
            value: "class"
        }
    ]
};

const trackMatomoClickEvent = {
    actionType: "triggerMatomoEvent",
    properties: {
        category: "Burger C",
        action: "Cliquer",
        name: ""
    }
};

class NestedLinksContainer extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: false
        };

        this.toggleExpand = this.toggleExpand.bind(this);
    }

    toggleExpand() {
        this.setState({ isExpanded: !this.state.isExpanded });
    }

    onLinkClick(actions = [], label) {
        if (actions.length) {
            trackMatomoClickEvent.properties.eventName = label;
            return this.props.dispatchSirenActions(
                //closing burger when switching to different pages
                [...actions, trackMatomoClickEvent, closeBurgerAction],
                this.props.widgetId,
                this.props.computedBindTo,
                ["default"]
            );
        }
    }

    createExpandBtn() {
        const icon = this.state.isExpanded ? "tq-icon-minus" : "tq-icon-plus";
        return (
            <li key={"button-expand"} onClick={this.toggleExpand}>
                <button className="tq-button un-nav-btn-blue">
                    <i className={icon}></i>
                </button>
            </li>
        );
    }

    addLinksContainer(list, child, index, additionalColor = "") {
        const childProps = NestedLinksContainer.getChildProps(child);
        childProps.style = {
            color: additionalColor
        };
        if (!child.actions) childProps.style.cursor = "default";
        const nestedChildren = {
            entities: child.entities,
            visible: childProps.visible
        };
        list.push(
            <Link
                key={`level-1-link-${index}`}
                {...childProps}
                onClick={() => this.onLinkClick(child.actions, childProps.label)}
            />
        );
        if (child.entities) {
            list.push(
                <LinksContainer
                    key={`links-container-${index}`}
                    {...nestedChildren}
                    widgetId={this.props.widgetId}
                    computedBindTo={this.props.computedBindTo}
                />
            );
        }
    }

    buildItems() {
        const props = this.getProps();
        const data = this.props.data || {};
        const children = data.entities || [];
        const result = [];

        children.forEach((child, index) => {
            const btn = this.createExpandBtn();

            if (props.visible < children.length) {
                if (!this.state.isExpanded) {
                    if (index < props.visible) {
                        this.addLinksContainer(result, child, index);
                    } else if (index === props.visible) {
                        result.push(btn);
                    }
                } else {
                    if (index >= props.visible) {
                        this.addLinksContainer(result, child, index);
                    }
                    if (index === children.length - 1) {
                        result.push(btn);
                    }
                }
            } else {
                this.addLinksContainer(result, child, index);
            }
        });

        return result;
    }

    getProps() {
        return extractComponentProps(this.props, {
            additionalProps: ["visible"],
            propsDefaults: {
                visible: Number.MAX_VALUE
            }
        });
    }

    static getChildProps(child) {
        const childProps = { config: {}, data: child };
        return extractComponentProps(childProps, {
            additionalProps: ["href", "label", "icon", "target", "extraClasses", "visible"],
            aliases: {
                href: "link",
                label: "value",
                icon: "image"
            },
            propsDefaults: {
                target: "_self",
                extraClasses: "tq-link tq-hyperlink un-hyperlink-special-title",
                visible: Number.MAX_VALUE
            }
        });
    }

    render() {
        const items = this.buildItems();
        return <ul className="tq-list-new">{items}</ul>;
    }
}

export default webui.connectComponent({
    actions: { dispatchSirenActions: "siren.dispatchSirenActions" }
})(NestedLinksContainer);
